import React from 'react'
import PropTypes from 'prop-types'
import Highcharts from 'highcharts'
import highchartsMore from 'highcharts/highcharts-more'
import solidGauge from 'highcharts/modules/solid-gauge'
import HighchartsReact from 'highcharts-react-official'
import theme from '../../config/styles/theme'

highchartsMore(Highcharts)
solidGauge(Highcharts)

const DonutChart = ({ color, value }) => {
  const options = {
    chart: {
      type: 'solidgauge',
      height: '100%'
    },
    tooltip: {
      enabled: false
    },
    title: {
      text: undefined
    },
    pane: {
      startAngle: 0,
      endAngle: 360,
      background: [
        {
          outerRadius: '100%',
          innerRadius: '0%',
          borderWidth: 0,
          backgroundColor: theme.palette.brand.gray2
        },
        {
          outerRadius: '62%',
          innerRadius: '0%',
          borderWidth: 0,
          backgroundColor: theme.palette.brand.white
        }
      ]
    },
    yAxis: {
      min: 0,
      max: 100,
      lineWidth: 0,
      tickPositions: []
    },
    plotOptions: {
      solidgauge: {
        dataLabels: {
          enabled: false,
          verticalAlign: 'middle'
        }
      }
    },
    series: [
      {
        data: [
          {
            color: theme.palette.charts[color],
            radius: '100%',
            y: value
          }
        ]
      }
    ]
  }
  return <HighchartsReact highcharts={Highcharts} options={options} />
}

DonutChart.defaultProps = {
  color: 'spray'
}

DonutChart.propTypes = {
  color: PropTypes.string,
  value: PropTypes.number
}

export default DonutChart
